class FacetFieldsetFilter extends HTMLElement {
  constructor() {
    super();
    const input = this.querySelector('input');

    input.addEventListener('input', (event) => {
      const filterValue = event.target.value;
      const isEmptyFilterValue = filterValue === null || filterValue === undefined || filterValue.trim() === "";

      const showMoreButton = event.target.closest('.parent-display').querySelector("show-more-button");
      if(showMoreButton) {
        if(isEmptyFilterValue) {
          showMoreButton.classList.remove("hidden");
        } else {
          showMoreButton.classList.add("hidden");
        }
      }

      const elements = event.target.closest('.parent-display').querySelectorAll('.facet-fieldset-filter-item');
      for(let i=0; i<elements.length; i++) {
        const element = elements[i];
        const filterItemValueElement = element.querySelector("[facet-fieldset-filter-value]");
        if(!filterItemValueElement) continue;

        const filterItemValue = filterItemValueElement.getAttribute("facet-fieldset-filter-value");

        if(isEmptyFilterValue && !element.classList.contains("show-more-item")) {
          element.classList.remove('hidden');          
        } else if(isEmptyFilterValue && element.classList.contains("show-more-item")) {
          element.classList.add('hidden');
        } else if(filterItemValue.includes(filterValue)) {
          element.classList.remove('hidden');
        } else{
          element.classList.add('hidden');
        }
      }
    });
  }
}

customElements.define('facet-fieldset-filter', FacetFieldsetFilter);
